import React from "react";
import { useTranslation } from "react-i18next";
import { formatDeltaPct } from "./intentInsightsService";
import styles from "./intentInsights.module.scss";

export default function FrictionPointsCard({ points }) {
  const { t } = useTranslation();

  if (!points?.length) return null;

  return (
    <article className={styles.insightCard}>
      <h3 className={styles.cardTitle}>{t("sonic_prospect.intent_insights.friction_title")}</h3>
      <ul className={styles.rankTable}>
        {points.map((row) => {
          const up = (row.deltaPct ?? 0) >= 0;
          return (
            <li key={row.id} className={styles.rankRow}>
              <span className={styles.rankLabel}>{row.label}</span>
              <span className={styles.rankValue}>
                {row.pct}% ({row.count})
              </span>
              <span className={up ? styles.deltaUp : styles.deltaDown}>
                {formatDeltaPct(row.deltaPct)}
              </span>
            </li>
          );
        })}
      </ul>
    </article>
  );
}
